function bankModuleuserManagement(){

    let userManagementService = [
        {
            name: "User Management",
            icon: "User Management",
            logoName: "userManagement",
            // flag: "voucherRequired",
            displayService: "bankUserManagement",
            items: [],
        },
    ]

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/user-management-dashboard",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const userManagement = () => {
        const userManagementArr = [
            {
                path: "/index/bank-back-office",
                name: "Back Office",
                icon: "Back Office",
                logoName: "userManagement",
                flag: "",
            },
        ];

        return userManagementArr;
    }

    let a = dashboard();
    let b = userManagement();

    userManagementService[0].items = [...a, ...b];

    return userManagementService;

}

export default bankModuleuserManagement;